import { Link } from 'react-router';
import { StapelLogo } from './stapel-logo';

export function Footer() {
  return (
    <footer id="footer" className="w-full bg-card/50">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between p-10">
        <div className="flex flex-col items-start justify-start gap-y-5 max-w-xs mx-0">
          <a className="flex items-center gap-2" href="#hero">
            <StapelLogo size={150} color="#111" />
          </a>
          <p className="tracking-tight text-muted-foreground">
            KI-Qualitätssicherung für das deutsche Vergabewesen.
          </p>
        </div>
        <div className="pt-5 md:w-1/2">
          <div className="flex flex-wrap items-start justify-end gap-x-8 gap-y-5 lg:pl-10">
            <ul className="flex flex-col gap-y-2">
              <li className="mb-2 text-sm font-semibold text-[#111]">
                Navigation
              </li>
              <li className="text-[15px]/snug text-muted-foreground hover:text-[#111] transition-colors">
                <a href="#features">Funktionen</a>
              </li>
              <li className="text-[15px]/snug text-muted-foreground hover:text-[#111] transition-colors">
                <a href="#security">Sicherheit</a>
              </li>
              <li className="text-[15px]/snug text-muted-foreground hover:text-[#111] transition-colors">
                <a href="#faq">FAQ</a>
              </li>
              <li className="text-[15px]/snug text-muted-foreground hover:text-[#111] transition-colors">
                <Link to="/demo">Demo anfragen</Link>
              </li>
            </ul>
            <ul className="flex flex-col gap-y-2">
              <li className="mb-2 text-sm font-semibold text-[#111]">
                Rechtliches
              </li>
              <li className="text-[15px]/snug text-muted-foreground hover:text-[#111] transition-colors">
                <Link to="/impressum">Impressum</Link>
              </li>
              <li className="text-[15px]/snug text-muted-foreground hover:text-[#111] transition-colors">
                <Link to="/datenschutz">Datenschutz</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="w-full py-4 flex justify-start items-center text-sm text-muted-foreground px-10 border-t border-border">
        <p>&copy; 2026 stapel.ai. Alle Rechte vorbehalten.</p>
      </div>
    </footer>
  );
}
